import React from 'react';
import Box from '@mui/material/Box';
const disclaimerText = 'We independently publish plant data to search multiple nurseries at once. We may earn a commission on qualifying purchases when you buy through our links.';
const defaultStyles = (theme) => ({
    fontFamily: 'system-ui, sans-serif',
    fontSize: 16,
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: '0.06em',
    textAlign: 'center',
    padding: theme.spacing(2.5, 0),
});
export default function Disclaimer({ sx }) {
    return (React.createElement(Box, { sx: [defaultStyles, ...(Array.isArray(sx) ? sx : [sx])] }, disclaimerText));
}
